export default __webpack_public_path__ + "static/media/LibraryIcon.263fcaf5.svg";